// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface InternalendpointsSessionDetailsCondition
 */
export interface InternalendpointsSessionDetailsCondition {
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsCondition
   */
  lastTransitionTime?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsCondition
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsCondition
   */
  reason?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsCondition
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsCondition
   */
  type?: string;
}

/**
 * Check if a given object implements the InternalendpointsSessionDetailsCondition interface.
 */
export function instanceOfInternalendpointsSessionDetailsCondition(
  value: object,
): value is InternalendpointsSessionDetailsCondition {
  return true;
}

export function InternalendpointsSessionDetailsConditionFromJSON(
  json: any,
): InternalendpointsSessionDetailsCondition {
  return InternalendpointsSessionDetailsConditionFromJSONTyped(json, false);
}

export function InternalendpointsSessionDetailsConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalendpointsSessionDetailsCondition {
  if (json == null) {
    return json;
  }
  return {
    lastTransitionTime:
      json['last_transition_time'] == null
        ? undefined
        : json['last_transition_time'],
    message: json['message'] == null ? undefined : json['message'],
    reason: json['reason'] == null ? undefined : json['reason'],
    status: json['status'] == null ? undefined : json['status'],
    type: json['type'] == null ? undefined : json['type'],
  };
}

export function InternalendpointsSessionDetailsConditionToJSON(
  json: any,
): InternalendpointsSessionDetailsCondition {
  return InternalendpointsSessionDetailsConditionToJSONTyped(json, false);
}

export function InternalendpointsSessionDetailsConditionToJSONTyped(
  value?: InternalendpointsSessionDetailsCondition | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    last_transition_time: value['lastTransitionTime'],
    message: value['message'],
    reason: value['reason'],
    status: value['status'],
    type: value['type'],
  };
}
